import { type Customer } from '@hungryroot/rest/api/v2/customers/self/get';
export {
  AuthState,
  type CustomerAuthState,
  useIdentify,
  invalidateCustomerData,
} from './hooks/useIdentify';
export { useLogin, type LoginParams } from './hooks/useLogin';
export { useSignup } from './hooks/useSignup';
export { useLogUser } from './hooks/useLogUser';
export { useUpdateCustomer } from './hooks/useUpdateCustomer';
export { RequireCheckedOut } from './components/RequireCheckedOut/RequireCheckedOut';
export { RequireNotCheckedOut } from './components/RequireNotCheckedOut/RequireNotCheckedOut';
export type { Customer };

export enum AccountStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Paused = 'paused',
  Skipped = 'skipped',
}

export function getCustomerDisplayName({
  first_name: firstName,
  last_name: lastName,
}: Pick<Customer, 'first_name' | 'last_name'>) {
  if (firstName === undefined && lastName === undefined) {
    return null;
  }

  const name: string[] = [];
  if (firstName !== undefined) {
    name.push(firstName);
  }

  if (lastName !== undefined) {
    name.push(lastName);
  }

  return name.join(' ');
}
